import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["type", "disabled"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import { Icon } from "@iconify/vue";
import { computed } from "vue";
import type { ButtonType, Size, Variant } from "./types";

interface Props {
  variant?: Variant;
  size?: Size;
  type?: ButtonType;
  disabled?: boolean;
  loading?: boolean;
  icon?: string;
  iconSrc?: string;
  iconPosition?: "left" | "right";
  block?: boolean;
  rounded?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    variant: { default: "primary" },
    size: { default: "md" },
    type: { default: "button" },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    icon: {},
    iconSrc: {},
    iconPosition: { default: "left" },
    block: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const buttonClasses = computed(() => {
  const classes = ["ui-button"];

  // Variant
  classes.push(`ui-button--${props.variant}`);

  // Size
  classes.push(`ui-button--${props.size}`);

  // States
  if (props.disabled || props.loading) classes.push("ui-button--disabled");
  if (props.loading) classes.push("ui-button--loading");
  if (props.block) classes.push("ui-button--block");
  if (props.rounded) classes.push("ui-button--rounded");

  return classes;
});

const iconClasses = computed(() => {
  const classes = ["ui-button__icon"];
  if (props.iconPosition === "left") classes.push("ui-button__icon--left");
  if (props.iconPosition === "right") classes.push("ui-button__icon--right");
  return classes;
});

const handleClick = (event: MouseEvent) => {
  if (!props.disabled && !props.loading) {
    emit("click", event);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: __props.type,
    disabled: __props.disabled || __props.loading,
    class: _normalizeClass(buttonClasses.value),
    onClick: handleClick
  }, [
    (__props.loading)
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 0,
          icon: "svg-spinners:ring-resize",
          class: "ui-button__loading-icon"
        }))
      : _createCommentVNode("", true),
    (__props.iconSrc && !__props.loading && __props.iconPosition === 'left')
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: __props.iconSrc,
          class: _normalizeClass(iconClasses.value)
        }, null, 10, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.icon && !__props.loading && __props.iconPosition === 'left')
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 2,
          icon: __props.icon,
          class: _normalizeClass(iconClasses.value)
        }, null, 8, ["icon", "class"]))
      : _createCommentVNode("", true),
    (_ctx.$slots.default)
      ? (_openBlock(), _createElementBlock("span", {
          key: 3,
          class: _normalizeClass({ 'button-text': __props.iconSrc || __props.icon || __props.loading })
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2))
      : _createCommentVNode("", true),
    (__props.iconSrc && !__props.loading && __props.iconPosition === 'right')
      ? (_openBlock(), _createElementBlock("img", {
          key: 4,
          src: __props.iconSrc,
          class: _normalizeClass(iconClasses.value)
        }, null, 10, _hoisted_3))
      : _createCommentVNode("", true),
    (__props.icon && !__props.loading && __props.iconPosition === 'right')
      ? (_openBlock(), _createBlock(_unref(Icon), {
          key: 5,
          icon: __props.icon,
          class: _normalizeClass(iconClasses.value)
        }, null, 8, ["icon", "class"]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})